import { colors } from '@casavo/base-ui'
import cn from 'classnames'
import React from 'react'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { PoiCategory } from '@/types/poi'

import { poiFilterButton } from './styles.css'

export const PoiFilterButton: React.FC<{
  handlePoiFilter: (f: PoiCategory) => void
  isActive: boolean
  label: string
  poiCategory: PoiCategory
}> = ({ handlePoiFilter, isActive, label, poiCategory }) => {
  const poiCategoryIcon = (() => {
    switch (poiCategory) {
      case 'TRANSPORT':
        return <TransportIcon aria-hidden="true" isActive={isActive} />
      case 'SCHOOL':
        return <SchoolIcon aria-hidden="true" isActive={isActive} />
      default:
        return <ShopIcon aria-hidden="true" isActive={isActive} />
    }
  })()

  return (
    <button
      className={cn('poi-filter-button', isActive ? poiFilterButton.active : poiFilterButton.default)}
      onClick={() => handlePoiFilter(poiCategory)}
    >
      {poiCategoryIcon}
      <span className={sprinkles({ marginLeft: 's' })}>{label}</span>
    </button>
  )
}

const TransportIcon: React.FC<{ isActive: boolean }> = ({ isActive }) => {
  return (
    <svg fill="none" height="18" viewBox="0 0 45 45" width="18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6562 28.125C12.6562 29.6783 13.9154 30.9375 15.4688 30.9375C17.0221 30.9375 18.2812 29.6783 18.2812 28.125C18.2812 26.5717 17.0221 25.3125 15.4688 25.3125C13.9154 25.3125 12.6562 26.5717 12.6562 28.125Z"
        fill={isActive ? colors.greyscale600 : colors.orange600}
      />
      <path
        d="M26.7188 28.125C26.7188 29.6783 27.9779 30.9375 29.5312 30.9375C31.0846 30.9375 32.3438 29.6783 32.3438 28.125C32.3438 26.5717 31.0846 25.3125 29.5312 25.3125C27.9779 25.3125 26.7188 26.5717 26.7188 28.125Z"
        fill={isActive ? colors.greyscale600 : colors.orange600}
      />
      <path
        d="M30.9375 11.25H14.0625V19.6875H30.9375V11.25Z"
        fill={isActive ? colors.greyscale600 : colors.orange600}
      />
      <path
        clipRule="evenodd"
        d="M14.0625 0C7.8493 0 2.8125 5.0368 2.8125 11.25V33.75C2.8125 36.8566 5.3309 39.375 8.4375 39.375H9.375L5.625 45H11.25L15 39.375H30L33.75 45H39.375L35.625 39.375H36.5625C39.6691 39.375 42.1875 36.8566 42.1875 33.75V11.25C42.1875 5.0368 37.1507 0 30.9375 0H14.0625ZM30.9375 5.625H14.0625C10.9559 5.625 8.4375 8.1434 8.4375 11.25L8.4375 33.75H36.5625V11.25C36.5625 8.1434 34.0441 5.625 30.9375 5.625Z"
        fill={isActive ? colors.greyscale600 : colors.orange600}
        fillRule="evenodd"
      />
    </svg>
  )
}

const SchoolIcon: React.FC<{ isActive: boolean }> = ({ isActive }) => {
  return (
    <svg fill="none" height="18" viewBox="0 0 45 45" width="18" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M8.4375 23.2031L5.625 21.0938V30.9375C5.625 32.4908 4.3658 33.75 2.8125 33.75C1.2592 33.75 0 32.4908 0 30.9375V14.0625L22.5 0L45 16.875L36.5625 23.2031V39.6302C36.5625 40.3443 36.1878 41.0061 35.5754 41.3736C27.5272 46.2025 17.4728 46.2025 9.42459 41.3736C8.8122 41.0061 8.4375 40.3443 8.4375 39.6302V23.2031ZM22.5 7.03125L9.375 16.875L22.5 26.7188L35.625 16.875L22.5 7.03125ZM14.0625 27.4219V37.4816C19.4021 39.9998 25.5979 39.9998 30.9375 37.4816V27.4219L22.5 33.75L14.0625 27.4219Z"
        fill={isActive ? colors.greyscale600 : colors.orange600}
        fillRule="evenodd"
      />
    </svg>
  )
}

const ShopIcon: React.FC<{ isActive: boolean }> = ({ isActive }) => {
  return (
    <svg fill="none" height="18" viewBox="0 0 45 45" width="18" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M5.625 0H0V5.625H5.625L8.18424 31.2174C8.32801 32.6551 9.53785 33.75 10.9828 33.75H34.5354C35.7459 33.75 36.8207 32.9754 37.2035 31.8269L45 8.4375H11.544L11.25 5.625C11.25 2.5184 8.7316 0 5.625 0ZM13.5281 28.125L12.1218 14.0625H37.1957L32.5082 28.125H13.5281Z"
        fill={isActive ? colors.greyscale600 : colors.orange600}
        fillRule="evenodd"
      />
      <path
        d="M12.6562 45C10.3263 45 8.4375 43.1112 8.4375 40.7812C8.4375 38.4513 10.3263 36.5625 12.6562 36.5625C14.9862 36.5625 16.875 38.4513 16.875 40.7812C16.875 43.1112 14.9862 45 12.6562 45Z"
        fill={isActive ? colors.greyscale600 : colors.orange600}
      />
      <path
        d="M32.3438 45C30.0138 45 28.125 43.1112 28.125 40.7812C28.125 38.4513 30.0138 36.5625 32.3438 36.5625C34.6737 36.5625 36.5625 38.4513 36.5625 40.7812C36.5625 43.1112 34.6737 45 32.3438 45Z"
        fill={isActive ? colors.greyscale600 : colors.orange600}
      />
    </svg>
  )
}
